<!-- <li class="panel"> -->
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(esito)" class="btn btn-primary associa"
				type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-2">{{esito.tipoEsito.descrizione}}</h4>
		<p class="col-sm-1">
			Numero <strong>{{esito.numeroEsito}}</strong>
		</p>
		<p class="col-sm-2">
			Data deposito: <strong>{{esito.dataDeposito ?
				(esito.dataDeposito | date:'dd/MM/yyyy'): ''}}</strong>
		</p>
		<p class="col-sm-2">
			Data notifica: <strong>{{esito.dataNotifica ?
				(esito.dataNotifica | date:'dd/MM/yyyy'): ''}}</strong>
		</p>
		<!-- <p class="col-sm-2">
			Data impugnazione: <strong>{{esito.dataImpugnazione ?
				(esito.dataImpugnazione | date:'dd/MM/yyyy'): ''}}</strong>
		</p> -->
		<p class="col-sm-2">
			Definitivo: <strong>{{esito.definitivo ? "Si" : "No"}}</strong>
		</p>
		<p class="col-sm-2">
			Esito: <strong>{{esito.esitoPerSocieta.label}}</strong>
		</p>
	</div>
</div>
<!-- </li> -->
